import React, { useContext, useEffect, useRef, useState } from "react";
import { Collapse, Modal } from "react-bootstrap";
import InputForm from "../../../Components/InputForm/InputForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./Accordian.css";
import { APICall } from "../../../Helpers/API/APICalls";
import { Tooltip } from "antd";
import {
  insertUpdateDashboardData,
  getTicketHistory,
  insertTicketHistory,
  isSaturdayOrWeekendForDashboard,
  //yogesh
  getTicketDownloadData,
  FileDownloadTicket
} from "../../../Helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../Helpers/ToastNotification";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import { BsExclamationCircle } from "react-icons/bs";
import { Box, Modal as Modal2 } from "@mui/material";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
//added by yogesh
import axios from "axios";
import fileDownload from "js-file-download";

const Accordian3 = ({
  data: mainData,
  statusDropdown,
  natureOfIssueDropdown,
  setDashboardData,
  totalReportedHoursToday,
  futureDate = false,
  backdatedDate,
  backDatedStatus,
  ticketTypeDropDown,
  resourceAllocate,
}) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [status, setStatus] = useState<any>({});
  const { EmployeeId } = getContext();
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [ticketHistoryData, setTicketHistoryData] = useState([]);
  //component state
  const [data, setData] = useState<any>(mainData);
  const [open, setOpen] = useState(false);
  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalReturnValue, setConfirmationModalReturnValue] =
    useState(false);

  //sangam
  const [tickettype, setTicketId] = useState<any>({});
  const [formErrors, setFormErrors] = useState({});
  //console.log(data);
  const [isNotWorkingDay, setIsNotWorkingDay] = useState(false);        //Deepak Gupta
  const [showConfirmationForDate, setShowConfirmationForDate] = useState(false);       //Deepak Gupta
  const [confirmationForDateModal, setConfirmationForDateModal] = useState(false);     //Deepak Gupta

  const [fileUrl, setFileUrl] = useState(null); //added by yogesh
  const [SharePointLink, setSharePointLink] = useState(""); // Amogh
  //add by yogesh
  const [isOpen, setIsOpen] = useState(false);
  //const [downloadData, setDownloadData] = useState([]);
  const [downloadDataTicket, setDownloadDataTicket] = useState([]);
  const customColors = ["#2755f3"];

  let formErrorObj = {};
  const closeConfirmationModal = (confirmation) => {
    if (confirmation) {
      setConfirmationModalReturnValue(confirmation);
    }
    setShowConfirmationModal(false);
  };

  //Added by Deepak Gupta
  const closeConfirmationModalForDate = (confirmation) => {
    if (confirmation) {
      setConfirmationForDateModal(confirmation);
    }
    setShowConfirmationForDate(false);
  };

  const handleOpen = async (id) => {
    gettickethistory(id);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  //Added by Deepak Gupta
  const getIsSaturdayOrWeekendForDashboard = async () => {
    let now = new Date().getHours();

    let timesheetDateToBe;
    /**
     *  check if value in now is between 12am and 6am
     *  12am -> 0
     *  6am -> 6
     */
    if (backDatedStatus) {
      timesheetDateToBe = moment(backdatedDate).format(moment.HTML5_FMT.DATE);
    } else {
      if (now >= 0 && now <= 6) {
        timesheetDateToBe = moment(new Date())
          .subtract(1, "day")
          .format(moment.HTML5_FMT.DATE);
      } else {
        timesheetDateToBe = moment(new Date()).format(moment.HTML5_FMT.DATE);
      }
    }


    let postObject = {
      assignedTo: resourceAllocate.value,
      timesheetDateToBe: timesheetDateToBe,
    }
    const { data } = await APICall(isSaturdayOrWeekendForDashboard, "POST", postObject);
    // console.log('==>', data.isNotWorkingDay)
    // if (data !== undefined && data.length > 0) {
    setIsNotWorkingDay(data.isNotWorkingDay);
    // console.log("Hello=>" + isNotWorkingDay)
    //}
  }
  const handleFileUrlClickForTicket = (url, engagment, ticketId, createdDate) => {
    setIsOpen(true);

    const fileUrls = url.split(",");

    //To get the file name from url    ---Deepak Gupta
    const GetNameFromFileUrl = (fileUrl) =>{
      
      let decodeUrl = decodeURIComponent(fileUrl);
      if(decodeUrl.includes("&file="))
      {
        return decodeUrl.split("&file=")[1].split("&action=")[0];
      }
      else if(decodeUrl.includes("/Tickets/"))
      {
        return decodeUrl.replace(/.*Tickets/, "").replace(/.*\//,"");
      }else {
        return decodeUrl;
      }
    }


    let fromatdate = createdDate.toLocaleDateString();
    const engagementObjects = fileUrls.map((fileUrl, index) => ({
      engagement: engagment,
      fileUrl: fileUrl,
      ticketId: ticketId,
      createddate: fromatdate,
      document: GetNameFromFileUrl(fileUrl)
    }));

    setDownloadDataTicket(engagementObjects);

  };


  const downloadoptions = {
    selectableRows: "none",
    count: false,
    rowsPerPage: false,
    serverSide: false,
    rowsPerPageOptions: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,

    setCellHeaderProps: () => ({ align: "center" }),
  };

  const AttachmentsGridColumnsForTicket = [
    {
      name: "engagement",
      label: "Engagement",
      options: {
        display: true,
      },
    },
    {
      name: "document",
      label: "Attachments",
      options: {
        display: true,
      },
    },
    {
      name: "fileUrl",
      label: "FileUrl",
      options: {
        display: false,
      },
    },
    {
      name: "ticketId",
      label: "TicketId",
      options: {
        display: true,
      },
    },
    {
      name: "createddate",
      label: "Created date",
      options: {
        display: true,
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        sort: false,
        filter: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const engagement = tableMeta.rowData[0];
          const fileUrl = tableMeta.rowData[2];
          const ticketId = tableMeta.rowData[3];
          const createdDate = tableMeta.rowData[4];
          //console.log(engagement, fileUrl, ticketId, createdDate)
          const handleDownloadTicket = () => {
            {

              let reqparam = {
                FileUrl: fileUrl,
                EngagementString: engagement,
              };
              axios
                .request({
                  responseType: "blob",
                  method: "POST",
                  url: FileDownloadTicket,
                  data: reqparam,
                  headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Headers": "*",
                  },
                })
                .then((response) => {
                  const contentDisposition =
                    response.headers["content-disposition"];

                  // Extract the filename using a regular expression
                  // const filenameRegex =
                  //   /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                  // const matches =
                  //   filenameRegex.exec(contentDisposition);

                  // let filename = "";
                  // if (matches != null && matches[1]) {
                  //   filename = matches[1].replace(/['"]/g, "");
                  // }

                  // Extract the file extension
                  //const fileExtension = filename.substring(filename.lastIndexOf('.'));


                  // //addded by yogesh
                  // const getFileExtension = (filename) => {
                  //   return filename
                  //     .slice(
                  //       ((filename.lastIndexOf(".") - 1) >>> 0) +
                  //       2
                  //     )
                  //     .toLowerCase();
                  // };

                  // const fileExtension =
                  //   getFileExtension(filename);

                //addded by yogesh
                  function getFileNameFromUrl(url) {
                    const parsedUrl = new URL(url);

                    let fileName = parsedUrl.pathname.split('/').pop();

                    if (fileName.toLowerCase() === 'doc.aspx') {
                      fileName = parsedUrl.searchParams.get('file');
                    }

                    if (fileName) {
                      fileName = decodeURIComponent(fileName.split('&')[0]);
                    }

                    return fileName || null;
                  }

                  const fileName = getFileNameFromUrl(fileUrl);
                  fileDownload(response.data, fileName);


                //   if (filename === "Doc.aspx") {
                //     // For .docx file download
                //     const docxFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.doc`;
                //     fileDownload(response.data, docxFileName);
                //   } else if (fileExtension === "pdf") {
                //     // For .pdf file download
                //     const pdfFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.pdf`;
                //     fileDownload(response.data, pdfFileName);
                //   } else if (fileExtension === "doc") {
                //     // For .doc file download
                //     const docFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.doc`;
                //     fileDownload(response.data, docFileName);
                //   } else if (fileExtension === "png") {
                //     // For .png file download
                //     const pngFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.png`;
                //     fileDownload(response.data, pngFileName);
                //   } else if (fileExtension === "jpeg") {
                //     // For .jpeg or .jpg file download
                //     const jpegFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.jpeg`;
                //     fileDownload(response.data, jpegFileName);
                //   } else if (fileExtension === "jpg") {
                //     const jpgFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.jpg`;
                //     fileDownload(response.data, jpgFileName);
                //   } else if (
                //     fileExtension === "ppt" ||
                //     fileExtension === "pptx"
                //   ) {
                //     // For .ppt or .pptx file download
                //     const pptFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.pptx`;
                //     fileDownload(response.data, pptFileName);
                //   } else if (fileExtension === "xlsx") {
                //     // For .xlsx file download
                //     const xlsxFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.xlsx`;
                //     fileDownload(response.data, xlsxFileName);
                //   } else if (fileExtension === "eml") {
                //     // For .eml file download
                //     const emlFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.eml`;
                //     fileDownload(response.data, emlFileName);
                //   } else if (fileExtension === "docx") {
                //     // For .docx file download
                //     const docxFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.docx`;
                //     fileDownload(response.data, docxFileName);
                //   } else {
                //     // For unhandled file types, use the extension dynamically
                //     const defaultFileName = `Ticket_${ticketId}_${moment(
                //       createdDate,
                //       "MM-DD-YYYY"
                //     ).format("DD-MMMM-YYYY")}.${fileExtension}`;
                //     fileDownload(response.data, defaultFileName);
                //   }

                })
                .catch((error) => {
                  if (error) {
                    notify(
                      1,
                      "File not found or an error occurred during the download."
                    );
                  }

                });

            }

          };

          return (
            <>
              <Tooltip title="Download" color={customColors[0]}>
                <a className="action_icon" onClick={handleDownloadTicket}>
                  <i
                    className="fa-solid fa-download"
                    aria-hidden="true"

                  ></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    }
  ];



  //Add by yogesh
  // const handleDownload = async (TicketId) => {
  //   console.log(TicketId);
  //   const postObject = {
  //     TicketId: TicketId, // Use a comma instead of a semicolon
  //   };

  //   const data = await APICall(getTicketDownloadData, "POST", postObject);
  //   console.log(data);
  //   let fileUrl2;

  //   console.log(data);
  //   if (data.data.fileUrl !== null) {
  //     fileUrl2 = data.data[0].fileUrl;
  //   }
  //   const requestObjectForDownload = {
  //     EngagementString: data.data[0].engagementString,
  //     FileUrl: fileUrl2,
  //   };
  //   console.log(fileUrl2);


  //   if (fileUrl2 !== null) {
  //     axios
  //       .request({
  //         responseType: "blob",
  //         method: "POST",
  //         url: FileDownloadTicket,
  //         data: requestObjectForDownload,
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           "Content-Type": "application/json",
  //           "Access-Control-Allow-Headers": "*",
  //         },
  //       })
  //       .then((response) => {
  //         const contentDisposition = response.headers["content-disposition"];

  //         // Extract the filename using a regular expression
  //         const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  //         const matches = filenameRegex.exec(contentDisposition);

  //         let filename = "";
  //         if (matches != null && matches[1]) {
  //           filename = matches[1].replace(/['"]/g, "");
  //         }

  //         // Extract the file extension
  //         //const fileExtension = filename.substring(filename.lastIndexOf('.'));

  //         //addded by kausher
  //         const getFileExtension = (filename) => {
  //           return filename
  //             .slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2)
  //             .toLowerCase();
  //         };

  //         const fileExtension = getFileExtension(filename);

  //         // Use the extracted filename and file extension
  //         if (filename === "Doc.aspx") {
  //           // For .docx file download
  //           const docxFileName = `${data.data[0].engagementString
  //             }-${TicketId}-${moment(data.data.createdDate).format("DD/MMMM/YYYY")}.doc`;
  //           fileDownload(response.data, docxFileName);
  //         } else if (fileExtension === "pdf") {
  //           // For .pdf file download
  //           const pdfFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.pdf`;
  //           fileDownload(response.data, pdfFileName);
  //         } else if (fileExtension === "doc") {
  //           // For .doc file download
  //           const docFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.doc`;
  //           fileDownload(response.data, docFileName);
  //         } else if (fileExtension === "png") {
  //           // For .png file download
  //           const pngFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.png`;
  //           fileDownload(response.data, pngFileName);
  //         } else if (fileExtension === "jpeg") {

  //           const jpegFileName = `${data.data[0].engagementString
  //             }-${TicketId}-${moment(data.data.createdDate).format(
  //               "DD/MMMM/YYYY"
  //             )}.jpeg`;
  //           fileDownload(response.data, jpegFileName);
  //         } else if (fileExtension === "jpg") {
  //           const jpgFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.jpg`;
  //           fileDownload(response.data, jpgFileName);
  //         } else if (fileExtension === "ppt" || fileExtension === "pptx") {
  //           // For .ppt or .pptx file download
  //           const pptFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.pptx`;
  //           fileDownload(response.data, pptFileName);
  //         } else if (fileExtension === "xlsx") {
  //           // For .xlsx file download
  //           const xlsxFileName = `${data.data[0].engagementString
  //             }-${TicketId}-${moment(data.data.createdDate).format(
  //               "DD/MMMM/YYYY"
  //             )}.xlsx`;
  //           fileDownload(response.data, xlsxFileName);
  //         } else if (fileExtension === "eml") {
  //           // For .eml file download
  //           const emlFileName = `${data.data[0].engagementString}-${TicketId}-${moment(
  //             data.data.createdDate
  //           ).format("DD/MMMM/YYYY")}.eml`;
  //           fileDownload(response.data, emlFileName);
  //         } else if (fileExtension === "docx") {
  //           // For .eml file download
  //           const docxFileName = `${data.data[0].engagementString
  //             }-${TicketId}-${moment(data.createdDate).format(
  //               "DD/MMMM/YYYY"
  //             )}.docx`;
  //           fileDownload(response.data, docxFileName);
  //         } else {
  //           // For unhandled file types, use the extension dynamically
  //           const defaultFileName = `${data.data[0].engagementString
  //             }-${TicketId}-${moment(data.data.createdDate).format(
  //               "DD/MMMM/YYYY"
  //             )}.${fileExtension}`;
  //           fileDownload(response.data, defaultFileName);
  //         }
  //       })
  //       .catch((error) => {
  //         if (error) {
  //           notify(
  //             1,
  //             "File not found or an error occurred during the download."
  //           );
  //         }
  //         console.error(error.response.data);
  //       });
  //   }
  // }

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      ticketNatureOfIssue: data.ticketNatureOfIssue,
    }));
  }, []);



  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "status") {
      if (event.id === 11 || event.id === 12) {
        hoursSpentRef.current.innerText = 0;
      } else if (event.id === 7) {
        if (data.responedDate === null) {
          setData((prev) => {
            return {
              ...prev,
              responedDate: new Date(),
            };
          });
        }
      } else if (event.id === 8) {
        if (data.responedDate === null) {
          setData((prev) => {
            return {
              ...prev,
              responedDate: new Date(),
            };
          });
        }
      } else if (event.id === 9) {
        if (data.responedDate === null) {
          setData((prev) => {
            return {
              ...prev,
              responedDate: new Date(),
            };
          });
        }
      } else if (event.id === 10) {
        if (data.responedDate === null && data.actualEndDate === null) {
          setData((prev) => {
            return {
              ...prev,
              responedDate: new Date(),
              actualEndDate: new Date(),
            };
          });
        } else if (data.responedDate !== null && data.actualEndDate === null) {
          setData((prev) => {
            return {
              ...prev,
              actualEndDate: new Date(),
            };
          });
        }
      }

      setData((prev) => {
        return {
          ...prev,
          status: event,
          tickettype: null, //sangam
        };
      });
      setFormErrors({});
    } else if (apiFieldName === "nature") {
      setData((prev) => {
        return {
          ...prev,
          ticketNatureOfIssue: event,
        };
      });
    } else if (apiFieldName === "ticketType") {
      //sangam
      setData((prev) => {
        return {
          ...prev,
          tickettype: event,
          issueCause: "",
          correctiveAction: "",
          preventionForRecurrance: "",
          similarProblem: "",
        };
      });
      setFormErrors({});
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticketType_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticketType_isEmpty"]: "Ticket type can not be empty",
        }));
      }
    }
  };

  const hoursSpentRef = useRef<any>();

  useEffect(() => {
    getIsSaturdayOrWeekendForDashboard();     //Deepak Gupta
    hoursSpentRef.current.innerText = data.todayHoursSpent;
  }, []);

  useEffect(() => {
    //alert("Accordian backdated");
    hoursSpentRef.current.innerText = data.todayHoursSpent;
  }, [backdatedDate]);

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    //sangam
    if (apiFieldName === "IssueCause") {
      setData((prev) => {
        return {
          ...prev,
          issueCause: event.target.value,
        };
      });

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["issueCause_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["issueCause_isEmpty"]: "Issue Cause can not be empty",
        }));
      }
    } else if (apiFieldName === "CorrectiveAction") {
      setData((prev) => {
        return {
          ...prev,
          correctiveAction: event.target.value,
        };
      });

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["correctiveAction_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["correctiveAction_isEmpty"]: "Corrective Action can not be empty",
        }));
      }
    } else if (apiFieldName === "PreventionForRecurrance") {
      setData((prev) => {
        return {
          ...prev,
          preventionForRecurrance: event.target.value,
        };
      });

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["preventionForRecurrance_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["preventionForRecurrance_isEmpty"]:
            "Prevention for recurrance can not be empty",
        }));
      }
    } else if (apiFieldName === "SimilarProblem") {
      setData((prev) => {
        return {
          ...prev,
          similarProblem: event.target.value,
        };
      });
      // if (
      //   event.target.value &&
      //   event.target.value !== "" &&
      //   event.target.value.toString().trim() !== ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["similarProblem_isEmpty"]: undefined,
      //   }));
      // } else if (
      //   !event.target.value ||
      //   event.target.value === "" ||
      //   event.target.value.toString().trim() === ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["similarProblem_isEmpty"]: "Similar problem in elsewhere can not be empty",
      //   }));
      // }
    } else if (apiFieldName === "thoursSpent") {
      // setData((prev) => {
      //   return {
      //     ...prev,
      //     todayHoursSpent: hoursSpentRef.current.innerText,
      //   };
      // });
    } else if (apiFieldName === "remarks") {
      setData((prev) => {
        return {
          ...prev,
          remarks: event.target.value,
        };
      });
    } else if (apiFieldName === "responded") {
      setData((prev) => {
        return {
          ...prev,
          responedDate: event,
        };
      });
    } else if (apiFieldName === "resolved") {
      setData((prev) => {
        return {
          ...prev,
          actualEndDate: event,
        };
      });
    }
  };

  const checkValidation = (data) => {
    let validator = true;
    if (data.todayHoursSpent === null || data.todayHoursSpent < 0) {
      validator = false;
    } else if (data.status === 7) {
      if (data.responedDate === null || data.todayHoursSpent === null) {
        validator = false;
      }
    } else if (data.status === 10) {
      if (data.actualEndDate === null || data.todayHoursSpent === null) {
        validator = false;
      }

      // if (data.remarks === null || data.remarks === "") {
      //   validator = false;
      // }
      //sangam
      if (data.tickettype === null || data.tickettype === "") {
        validator = false;
      }

      if (data.tickettype && data.tickettype === 1) {
        if (data.issueCase === null || data.issueCase === "") {
          validator = false;
        }
        if (data.correctiveAction === null || data.correctiveAction === "") {
          validator = false;
        }
        if (
          data.preventionForRecurrance === null ||
          data.preventionForRecurrance === ""
        ) {
          validator = false;
        }
        // if(data.similarProblem === null || data.similarProblem === ""){
        //   validator = false;
        // }
      }
    } else if (data.status === 15) {
      //sangam

      if (data.tickettype === null || data.tickettype === "") {
        validator = false;
      }
      if (data.tickettype && data.tickettype === 1) {
        if (data.issueCase === null || data.issueCase === "") {
          validator = false;
        }
        if (data.correctiveAction === null || data.correctiveAction === "") {
          validator = false;
        }
        if (
          data.preventionForRecurrance === null ||
          data.preventionForRecurrance === ""
        ) {
          validator = false;
        }
        // if(data.similarProblem === null || data.similarProblem === ""){
        //   validator = false;
        // }
      }
    } else if (
      data.ticketNatureOfIssue === null ||
      data.ticketNatureOfIssue === undefined
    ) {
      validator = false;
    }

    return validator;
  };

  //sangam

  const onSubmitValidation = async () => {
    await setFormErrors({});
    if (data.status.id === 15 || data.status.id === 10) {
      if (!data.tickettype || Object.keys(data.tickettype).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ticketType_isEmpty"]: "Ticket type can not be empty",
        }));
        formErrorObj["ticketType_isEmpty"] = "Ticket type can not be empty";

        if (data.tickettype && data.tickettype.value === 1) {
          if (
            !data.issueCause ||
            data.issueCause === "" ||
            data.issueCause.toString().trim() === ""
          ) {
            setFormErrors((preState) => ({
              ...preState,
              ["issueCause_isEmpty"]: "Issue Cause can not be empty",
            }));
            formErrorObj["issueCause_isEmpty"] = "Issue Cause can not be empty";
          }

          if (
            !data.correctiveAction ||
            data.correctiveAction === "" ||
            data.correctiveAction.toString().trim() === ""
          ) {
            setFormErrors((preState) => ({
              ...preState,
              ["correctiveAction_isEmpty"]:
                "corrective Action can not be empty",
            }));
            formErrorObj["correctiveAction_isEmpty"] =
              "corrective Action can not be empty";
          }

          if (
            !data.preventionForRecurrance ||
            data.preventionForRecurrance === "" ||
            data.preventionForRecurrance.toString().trim() === ""
          ) {
            setFormErrors((preState) => ({
              ...preState,
              ["preventionForRecurrance_isEmpty"]:
                "Prevention for recurrance can not be empty",
            }));
            formErrorObj["preventionForRecurrance_isEmpty"] =
              "Prevention for recurrance can not be empty";
          }

          // if (
          //   !data.similarProblem ||
          //   data.similarProblem === "" ||
          //   data.similarProblem.toString().trim() === ""
          // ) {
          //   setFormErrors((preState) => ({
          //     ...preState,
          //     ["similarProblem_isEmpty"]: "Similar problem in elsewhere can not be empty",
          //   }));
          //   formErrorObj["similarProblem_isEmpty"] = "Similar problem in elsewhere can not be empty";
          // }
        }
      }
    }
  };

  const updateData = async (data) => {
    let now = new Date().getHours();
    let timesheetDateToBe;
    /**
     *  check if value in now is between 12am and 6am
     *  12am -> 0
     *  6am -> 6
     */
    //sangam
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every(
      (f) => f === "" || f === null || f === undefined
    );
    if (isEmpty === true) {
      if (backDatedStatus) {
        timesheetDateToBe = moment(backdatedDate).format(moment.HTML5_FMT.DATE);
      } else {
        if (now >= 0 && now <= 6) {
          timesheetDateToBe = moment(new Date())
            .subtract(1, "day")
            .format(moment.HTML5_FMT.DATE);
        } else {
          timesheetDateToBe = moment(new Date()).format(moment.HTML5_FMT.DATE);
        }
      }
      let obj = {
        id: data.id,
        todayHoursSpent: isNaN(parseFloat(hoursSpentRef.current.innerText))
          ? null
          : parseFloat(hoursSpentRef.current.innerText),
        responedDate: data.responedDate
          ? moment(data.responedDate).format(moment.HTML5_FMT.DATE)
          : null,
        actualEndDate: data.actualEndDate
          ? moment(data.actualEndDate).format(moment.HTML5_FMT.DATE)
          : null,
        remarks: data.remarks,
        timesheetDateToBe: timesheetDateToBe,
        status: data.status.id,
        ticketNatureOfIssue: data.ticketNatureOfIssue.value,
        assignedTo: EmployeeId,
        rType: "Ticket",
        BackDatedStatus: backDatedStatus,
        //sagam
        tickettype:
          data.tickettype &&
          (data.tickettype ? Number(data.tickettype.value) : null),
        issueCause:
          data.issueCause && (data.issueCause ? data.issueCause : null),
        correctiveAction:
          data.correctiveAction &&
          (data.correctiveAction ? data.correctiveAction : null),
        preventionForRecurrance:
          data.preventionForRecurrance &&
          (data.preventionForRecurrance ? data.preventionForRecurrance : null),
        similarProblem:
          data.similarProblem &&
          (data.similarProblem ? data.similarProblem : null),
      };

      let isMax = false;
      let isNegative = false;
      //let checkisnull = false;

      // to check if totalreportedToday is > 16
      setDashboardData((prev) => {
        if (
          obj.todayHoursSpent < 0
          // || obj.todayHoursSpent === null
        ) {
          isNegative = true;
          return prev;
        } else {
          let newData = prev.map((ele) => {
            if (ele.id === data.id) {
              if (ele.todayHoursSpent === null) {
                return {
                  ...ele,
                  todayHoursSpent: parseFloat(hoursSpentRef.current.innerText),
                };
              } else {
                return {
                  ...ele,
                  todayHoursSpent:
                    parseFloat(ele.todayHoursSpent) +
                    parseFloat(hoursSpentRef.current.innerText),
                };
              }
            } else {
              return ele;
            }
          });

          let total = newData.reduce(
            (sum, data) => (sum = sum + data.todayHoursSpent),
            0
          );
          if (total > 16) {
            isMax = true;
            return prev;
          } else {
            isMax = false;
            return prev;
          }
        }
      });
      if (isNegative) {
        notify(1, "Invalid Data!");
      } else if (isMax) {
        notify(1, "Hours cannot be greater than 16");
      } else {
        let validate = checkValidation(obj);

        if (validate) {
          showLoader();
          const res = await APICall(insertUpdateDashboardData, "Post", obj);
          let historyinsertobj = {
            AssignedTo: Number(EmployeeId),
            TicketStatus: data.status?.id,
            Id: data.id,
            TicketNatureOfIssue: data.ticketNatureOfIssue.value,
            TicketTitle: data.title,
            TicketDescription: data.description,
            Remarks: data.remarks,
          };
          const { data2 } = await APICall(
            insertTicketHistory,
            "Post",
            historyinsertobj
          );
          hideLoader();
          if (res.status === 1) {
            notify(res.status, res.message);
          } else {
            setIsActive(!isActive);
            notify(0, "Hours updated successfully!");
            // update actual today hours
            setData((prev) => {
              if (prev.todayHoursSpent === null) {
                return {
                  ...prev,
                  todayHoursSpent: parseFloat(hoursSpentRef.current.innerText),
                };
              } else {
                return {
                  ...prev,
                  todayHoursSpent:
                    parseFloat(prev.todayHoursSpent) +
                    parseFloat(hoursSpentRef.current.innerText),
                };
              }
            });

            // update total today hours
            setDashboardData((prev) => {
              return prev.map((ele) => {
                if (ele.id === data.id) {
                  if (ele.todayHoursSpent === null) {
                    return {
                      ...ele,
                      todayHoursSpent: parseFloat(
                        hoursSpentRef.current.innerText
                      ),
                    };
                  } else {
                    return {
                      ...ele,
                      todayHoursSpent:
                        parseFloat(ele.todayHoursSpent) +
                        parseFloat(hoursSpentRef.current.innerText),
                    };
                  }
                } else {
                  return ele;
                }
              });
            });
          }
        } else {
          notify(1, "Please fill required field!");
        }
      }
    }
  };

  useEffect(() => {
    if (confirmationModalReturnValue) {
      updateData(data);
    }
    setConfirmationModalReturnValue(false);
    if (confirmationForDateModal) {      //Deepak Gupta
      updateData(data);
    }
    setConfirmationForDateModal(false);
  }, [confirmationModalReturnValue, confirmationForDateModal]);

  const gettickethistory = async (id) => {
    let getticketid = {
      TicketId: id,
    };
    const { data } = await APICall(getTicketHistory, "POST", getticketid);

    if (data != null || data != undefined) {
      await data.map(async (ticketh) => {
        ticketh.timesheetDate = await moment(ticketh.timesheetDate).format(
          "DD/MM/YYYY"
        );
      });
      setTicketHistoryData(data);
    }
  };

  const gridColumns = [
    // {
    //   name: "ticketId",
    //   label: "Task Id",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     sortDescFirst: true,
    //   },
    // },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "timesheetDate",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "empName",
      label: "User ",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "remarks",
      label: "Remarks ",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
  ];
  const options = {
    selectableRows: "none",
    // count: count,
    // rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false, //prashant
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    //prashant
    // onChangePage: async (page) => {
    //   setStart(page * pageSize);
    // },
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    // height : "80%",//prashant
    maxHeight: "650px", //prashant
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
    overflow: "auto", //prashant
  };

  return (
    <>
      {data && (
        <>
          <div className="card">
            <div
              style={{ backgroundColor: "#f2f2f2 !important" }}
              className="card-header"
              id="headingOne"
              onClick={() => setIsActive(!isActive)}
            >
              <div data-toggle="collapse" data-target="#collapseOne">
                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0">
                    {/* check status then render */}

                    {data?.status?.id === 10 ||
                      (data?.status?.id === 15 && (
                        <i
                          className="fa fa-check-circle mr-2"
                          aria-hidden="true"
                        ></i>
                      ))}
                    {(data?.status?.id === 8 || data?.status?.id === 9) && (
                      <i
                        className="fa fa-hourglass-end mr-2 yellow-col"
                        aria-hidden="true"
                      ></i>
                    )}

                    {data?.title}
                    <span className="float-right">
                      {" "}
                      <i className="fa fa-chevron-down"></i>{" "}
                    </span>
                  </div>
                </div>

                <div className="col-lg-12 row p-0 m-0">
                  <div className="col-lg-12 p-0 mt-2 sub-text">
                    <span>
                      {moment(data?.plannedEndDate).isBefore(
                        moment(),
                        "day"
                      ) && (
                          <i
                            className="fa fa-fire mr-2 red-col"
                            aria-hidden="true"
                          ></i>
                        )}
                      {data?.plannedEndDate?.toDateString() ===
                        new Date().toDateString() && (
                          <i
                            className="fa-solid fa-bookmark mr-2 yellow-col"
                            aria-hidden="true"
                          ></i>
                        )}
                      {data?.engagement &&
                        data?.phaseName === null &&
                        data?.applicationName === null && (
                          <>{data?.engagement}</>
                        )}
                      {data?.engagement && data?.phaseName && (
                        <>
                          {data?.engagement} - {data?.phaseName}
                        </>
                      )}
                      {data?.engagement && data?.applicationName && (
                        <>
                          {data?.engagement} - {data?.applicationName}
                        </>
                      )}
                    </span>
                    <span className="float-right red-col">
                      {data?.todayHoursSpent ? data?.todayHoursSpent : 0}
                      <span className="black-col">/{data?.hoursAssigned}H</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Collapse in={isActive}>
              <div>
                <>
                  {/* for ticket */}
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                  >
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          {/* {data.id} - {data.taskDescription} */}
                          {data.description && (
                            <>
                              <label>Description - </label> {data.description}
                            </>
                          )}
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Status</label>
                            <SelectForm
                              options={statusDropdown}
                              placeholder="Select"
                              isDisabled={false}
                              value={data.status}
                              onChange={(event) =>
                                selectOnChange(event, "status")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                              getOptionLabel={(options) => options.value}
                              getOptionValue={(options) => options.id}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Priority</label>
                            <SelectForm
                              options={natureOfIssueDropdown}
                              placeholder="Select"
                              isDisabled={false}
                              value={data.ticketNatureOfIssue}
                              onChange={(event) =>
                                selectOnChange(event, "nature")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                            />
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6">
                          <div className="form-group">
                            <label>Linked Ticket (for recurring)</label>
                            <SelectForm
                              options={[
                                {
                                  value: 1,
                                  label: "Linked Ticket 1",
                                },
                                {
                                  value: 2,
                                  label: "Linked Ticket 2",
                                },
                                {
                                  value: 3,
                                  label: "Linked Ticket 3",
                                },
                                {
                                  value: 4,
                                  label: "Linked Ticket 4",
                                },
                              ]}
                              placeholder="Select"
                              isDisabled={true}
                              value={status}
                              onChange={(event) =>
                                selectOnChange(event, "linked")
                              }
                              isMulti={false}
                              noIndicator={false}
                              noSeparator={false}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                          <div className="table-responsive">
                            <table
                              className="table table-bordered table_grid"
                              id="time-table"
                            >
                              <thead>
                                <tr>
                                  <th className=""></th>
                                  <th className="">Reported </th>
                                  <th className="">Responded</th>
                                  <th className="">Resolved</th>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="disabledEvent">
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={new Date(data.reportDate)}
                                            onChange={(e) =>
                                              handleTextEvent(e, "fromDate")
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            PopperProps={{
                                              disablePortal: true,
                                              modifiers: [
                                                {
                                                  name: "offset",
                                                  options: {
                                                    offset: [0, 8],
                                                  },
                                                },
                                                {
                                                  name: "preventOverflow",
                                                  options: {
                                                    enabled: true,
                                                    boundariesElement:
                                                      "viewport",
                                                  },
                                                },
                                              ],
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>
                                  <td className={"disabledEvent"}>
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={data.responedDate}
                                            onChange={(e) =>
                                              handleTextEvent(e, "responded")
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            PopperProps={{
                                              disablePortal: true,
                                              modifiers: [
                                                {
                                                  name: "offset",
                                                  options: {
                                                    offset: [0, 8],
                                                  },
                                                },
                                                {
                                                  name: "preventOverflow",
                                                  options: {
                                                    enabled: true,
                                                    boundariesElement:
                                                      "viewport",
                                                  },
                                                },
                                              ],
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>
                                  <td className={"disabledEvent"}>
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={data.actualEndDate}
                                            onChange={(e) =>
                                              handleTextEvent(e, "resolved")
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th className=""></th>
                                  <th className="">Planned </th>
                                  <th className="">Till Date</th>
                                  <th className="">Today</th>
                                </tr>

                                <tr>
                                  <td>Hours Spent</td>
                                  <td className="disabledEvent numRight">
                                    {data.hoursAssigned}
                                  </td>
                                  <td className="disabledEvent numRight">
                                    {data.hoursSpent}
                                  </td>
                                  <td
                                    className={
                                      data?.status?.id === 11 ||
                                        data?.status?.id === 12
                                        ? "disabledEvent numRight"
                                        : "numRight"
                                    }
                                    contentEditable={
                                      data?.status?.id === 11 ||
                                        data?.status?.id === 12
                                        ? false
                                        : true
                                    }
                                    ref={hoursSpentRef}
                                    onInput={(e) =>
                                      handleTextEvent(
                                        e.currentTarget.textContent,
                                        "thoursSpent"
                                      )
                                    }
                                  ></td>
                                </tr>
                                <tr>
                                  <th className=""></th>
                                  <th className="">Planned</th>
                                  <th className=""></th>
                                  <th className=""></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Completed Date</td>
                                  <td className="disabledEvent">
                                    <div className="">
                                      <div className="form-group">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDateFns}
                                        >
                                          <DatePicker
                                            label="Date"
                                            value={
                                              new Date(data.plannedEndDate)
                                            }
                                            onChange={(e) =>
                                              handleTextEvent(e, "fromDate")
                                            }
                                            inputFormat="dd/MM/yyyy"
                                            renderInput={(params) => (
                                              <TextField
                                                size="small"
                                                {...params}
                                              />
                                            )}
                                            PopperProps={{
                                              disablePortal: true,
                                              modifiers: [
                                                {
                                                  name: "offset",
                                                  options: {
                                                    offset: [0, 8],
                                                  },
                                                },
                                                {
                                                  name: "preventOverflow",
                                                  options: {
                                                    enabled: true,
                                                    boundariesElement:
                                                      "viewport",
                                                  },
                                                },
                                              ],
                                            }}
                                          />
                                        </LocalizationProvider>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="disabledEvent"></td>
                                  <td className="disabledEvent"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {!(
                          data.tickettype &&
                          (data?.status?.id == 15 || data?.status?.id == 10) &&
                          data?.tickettype.value == 1
                        ) && (
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label>Remark</label>
                                <InputForm
                                  placeholder={""}
                                  isDisabled={false}
                                  textArea={true}
                                  rows={3}
                                  value={data.remarks ? data.remarks : ""}
                                  onChange={(e) => handleTextEvent(e, "remarks")}
                                />
                              </div>
                            </div>
                          )}
                        {
                          //sangam

                          data.status &&
                          (data?.status?.id == 10 ||
                            data?.status?.id == 15) && (
                            <div className="col-lg-3 col-md-4 col-sm-6">
                              <div className="form-group">
                                <label>
                                  Ticket Type <sup>*</sup>
                                </label>
                                <SelectForm
                                  options={ticketTypeDropDown}
                                  placeholder="Select"
                                  isDisabled={false}
                                  value={
                                    data.tickettype ? data.tickettype : ""
                                  }
                                  onChange={(event) =>
                                    selectOnChange(event, "ticketType")
                                  }
                                  isMulti={false}
                                  noIndicator={false}
                                  noSeparator={false}
                                  getOptionLabel={(options) => options.label}
                                  getOptionValue={(options) => options.value}
                                />
                                <p style={{ color: "red" }}>
                                  {formErrors["ticketType_isEmpty"]}
                                </p>
                              </div>
                            </div>
                          )
                        }

                        {/* { //issue Causes
                                 data.tickettype &&(  (data.status?.id ==15 || data.status?.id == 10 ) && data.tickettype.value == 1 )&&(
                                 
                                 )  
                            } */}

                        {data.tickettype &&
                          (data?.status?.id == 15 || data?.status?.id == 10) &&
                          data.tickettype.value == 1 && (
                            <>
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    Issue Cause <sup>*</sup>
                                  </label>
                                  <InputForm
                                    placeholder={"Issue Cause"}
                                    isDisabled={false}
                                    textArea={true}
                                    rows={3}
                                    value={
                                      data.issueCause ? data.issueCause : ""
                                    }
                                    onChange={(e) =>
                                      handleTextEvent(e, "IssueCause")
                                    }
                                    style={{ height: "100px" }}
                                  />
                                  <p style={{ color: "red" }}>
                                    {formErrors["issueCause_isEmpty"]}
                                  </p>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    Corrective Action <sup>*</sup>
                                  </label>
                                  <InputForm
                                    placeholder={"Corrective Action"}
                                    isDisabled={false}
                                    textArea={true}
                                    rows={3}
                                    value={
                                      data.correctiveAction
                                        ? data.correctiveAction
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleTextEvent(e, "CorrectiveAction")
                                    }
                                    style={{ height: "100px" }}
                                  />
                                  <p style={{ color: "red" }}>
                                    {formErrors["correctiveAction_isEmpty"]}
                                  </p>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    Prevention For Recurrance <sup>*</sup>
                                  </label>
                                  <InputForm
                                    placeholder={"Prevention For Recurrance"}
                                    isDisabled={false}
                                    textArea={true}
                                    rows={3}
                                    value={
                                      data.preventionForRecurrance
                                        ? data.preventionForRecurrance
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleTextEvent(
                                        e,
                                        "PreventionForRecurrance"
                                      )
                                    }
                                    style={{ height: "100px" }}
                                  />
                                  <p style={{ color: "red" }}>
                                    {
                                      formErrors[
                                      "preventionForRecurrance_isEmpty"
                                      ]
                                    }
                                  </p>
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    Similar Problem In Elsewhere
                                    {/* <sup>*</sup> */}
                                  </label>
                                  <InputForm
                                    placeholder={"Similar Problem In Elsewhere"}
                                    isDisabled={false}
                                    textArea={true}
                                    rows={3}
                                    value={
                                      data.similarProblem
                                        ? data.similarProblem
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleTextEvent(e, "SimilarProblem")
                                    }
                                    style={{ height: "100px" }}
                                  />
                                  {/* <p style={{ color: "red" }}>
                                      {formErrors["similarProblem_isEmpty"]}
                                     </p> */}
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>Remark</label>
                                  <InputForm
                                    placeholder={""}
                                    isDisabled={false}
                                    textArea={true}
                                    rows={3}
                                    value={data.remarks ? data.remarks : ""}
                                    onChange={(e) =>
                                      handleTextEvent(e, "remarks")
                                    }
                                    style={{ height: "100px" }}
                                  />
                                </div>
                              </div>
                            </>
                          )}

                        {/* after selecting  */}

                        <div className="col-lg-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="fill-hours">
                              {/* <a>
                                    {" "}
                                    <i className="fa fa-file-alt mr-1"></i>
                                    RCA{" "}
                                  </a> */}
                              {" "}
                              <i className="fa fa-clock mr-1"></i> History{" "}

                              {data.sharePointLink !== null && (
                                <a
                                  className="mr-2"
                                  onClick={() => handleFileUrlClickForTicket(data.sharePointLink, data.engagement, data.id, data.plannedStartDate)}
                                  style={{ cursor: "pointer", }}
                                >
                                  <i className="fa fa-download mr-1"></i>
                                  Attachments
                                </a>
                              )}


                              {/* ended by yogesh */}

                            </div>
                            <div className="fillUpdate">
                              {/* <button className="btn btn-reset ml-1">
                                    Reset
                                  </button> */}
                              <button
                                style={{}}
                                disabled={
                                  (data?.status?.id === 6 ? true : false) ||
                                  (totalReportedHoursToday >= 16
                                    ? true
                                    : false) ||
                                  (futureDate ? true : false)
                                }
                                className="btn btn-update"
                                onClick={() => {
                                  let todayHoursSpent = isNaN(
                                    parseFloat(hoursSpentRef.current.innerText)
                                  )
                                    ? null
                                    : parseFloat(
                                      hoursSpentRef.current.innerText
                                    );

                                  if (isNotWorkingDay) {     //Deepak Gupta
                                    setShowConfirmationForDate(true);
                                  }
                                  else if (todayHoursSpent > 9) {
                                    setShowConfirmationModal(true);
                                  } else {
                                    updateData(data);
                                  }
                                }}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </Collapse>
          </div>
          <>
            <Modal
              show={showConfirmationModal}
              onHide={() => closeConfirmationModal(false)}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Confirmation <BsExclamationCircle color="yellow" />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You entered hours more than 9</p>
                <p>Do you want to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => closeConfirmationModal(false)}
                  className="btn btn-reset"
                >
                  No
                </button>
                <button
                  style={{ background: "#96c61c" }}
                  onClick={() => closeConfirmationModal(true)}
                  className="btn btn-submit"
                >
                  Yes
                </button>
              </Modal.Footer>
            </Modal>

            <Modal
              // open={open}
              // onClose={handleClose}
              // aria-labelledby="modal-modal-title"
              // aria-describedby="modal-modal-description"
              // hideBackdrop={true}
              show={open}
              onHide={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              backdrop="static"
              centered
              size="lg"
              scrollable={true}
            >
              <Modal.Header closeButton>
                <Modal.Title>History Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <DynamicGrid
                  options={options}
                  data={ticketHistoryData}
                  columns={gridColumns}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="btn btn-reset"
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </>
          { /*Added by yogesh */}
          <Modal
            show={isOpen}
            onHide={() => setIsOpen(false)}
            backdrop="static"
            keyboard={false}
            centered
            scrollable={true}
            size="lg"
            style={{ zIndex: 1050 }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Attachments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-12">
                  <DynamicGrid
                    columns={AttachmentsGridColumnsForTicket}
                    data={downloadDataTicket}
                    options={downloadoptions}
                  />
                </div>
                <div className="col-lg-12 mt-3">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => setIsOpen(false)}
                      className="btn btn-reset"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>


          { /*Added by Deepak Gupta*/}
          <>
            <Modal
              show={showConfirmationForDate}
              onHide={() => closeConfirmationModalForDate(false)}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title className="d-flex justify-content-center align-items-center gap-2">
                  Confirmation <BsExclamationCircle color="yellow" />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You are filling timesheet on Non-Working day</p>
                <p>Do you want to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <button
                  onClick={() => closeConfirmationModalForDate(false)}
                  className="btn btn-reset"
                >
                  No
                </button>
                <button
                  style={{ background: "#96c61c" }}
                  onClick={() => closeConfirmationModalForDate(true)}
                  className="btn btn-submit"
                >
                  Yes
                </button>
              </Modal.Footer>
            </Modal>
          </>

        </>
      )}
    </>
  );
};

export default Accordian3;
